import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src2405077067/src/compass-v2/packages/frontend/layouts/default.vue").then(m => m.default || m))
}